import { generateLazyContextProvider } from './LazyContext';
import { LazyOrganizationContext } from './LazyOrganizationContext';
import { apiOrganization } from '../resources/api/apiOrganization';

const { useGetOrganizationsByIdsSilent } = apiOrganization;

export const LazyOrganizationContextProvider = generateLazyContextProvider(
  LazyOrganizationContext,
  (item) => item.id,
  () => useGetOrganizationsByIdsSilent().execute
);
